<template>
    <v-card max-width="4520" raised="raised">
        <v-form ref="audioFileForm" class="fill-height" :lazy-validation="true" v-model="audioFileFormValid">

        <v-card-title>
            <v-icon class="mr-3">mdi-file-music</v-icon><span v-text="'Upload Audio File'"></span>
        </v-card-title>

        <v-divider />

        <v-card-text>
            <v-file-input color="#C42111" class="my-4" v-model="selectedFile" accept=".mp3, .wav" label="File" placeholder="Select a file" :show-size="1024" @change="sampleFile" :rules="[validation.maxSize(selectedFile), validation.sameName(selectedFile, $store.state.audioFiles)]"></v-file-input>
            <audio controls :src="selectedFileData" v-if="selectedFile" style="outline: none; width: 100%;">
                Your browser does not support the audio element.
            </audio>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-3" color="#c42111" @click="close">Cancel</v-btn>
            <v-btn color="#c42111" :disabled="!selectedFile" @click="saveFile">Save</v-btn>
        </v-card-actions>

        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'AudioFileUpload',
    props: [],
    components: {
    },
    data: () => ({
        selectedFile: null,
        selectedFileData: null,
        validation: {
            maxSize: (file) => ((!file || file.size < 5000000) || 'File size must be less than 5MB'),
            sameName: (file, fileList) => ((!file || !fileList.some(f => {return f.name == file.name})) || 'File name already exists. Delete the existing one first')
        },
        audioFileFormValid: true
    }),

    computed: {

    },

    methods: {
        sampleFile: function() {
            if(!this.selectedFile) {
                this.selectedFileData = null;
                return;
            }
            let reader = new FileReader();
            let self = this;
            reader.onload = function (e) {
                self.selectedFileData = e.target.result;
            }
            reader.readAsDataURL(this.selectedFile);
        },

        close: function() {
            this.selectedFile = null;
            this.selectedFileData = null;
            this.$emit('close');
        },

        saveFile: function() {
            if(this.$refs.audioFileForm.validate()) {
                this.selectedFile.data = this.selectedFileData;
                this.$emit('save', this.selectedFile);
            }
        }

    },

    mounted() {
    },
  
};
</script>

<style scoped>

</style>

